import { readable } from 'svelte/store'
import { loading } from "./Loading.svelte"

var _isLoading = false

export default {
    show: () => {
        loading.set(true)
    },
    hide: () => {
        loading.set(false)
    },
    isLoading: () => { return loading }
}
